import { Component, OnInit } from '@angular/core';
import {StsRegistrationType} from '../../../models/sts-registration-type.enum';
import {StsNotification} from '../../../models/sts-notification.model';
import {StsNotificationType} from '../../../models/sts-notification-type';
import {Router, ActivatedRoute} from '@angular/router';
import StsA360RegistrationResponseModel
  from '../../../models/sts-a360-registration-response.model';

@Component({
  selector: 'app-account-forgot-username',
  templateUrl: './account-forgot-username.component.html',
  styleUrls: ['./account-forgot-username.component.scss']
})
export class AccountForgotUsernameComponent implements OnInit {

  public errors: StsNotification[] = [];
  public mode: StsRegistrationType = StsRegistrationType.ForgotUserName;
  public username = '';
  public userId = '';
  public isChanged: boolean = false;

  constructor(private router: Router,
              private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.username = params['newUserName'];
      this.isChanged = !!this.username;
      this.userId = params['userId'];
    });
  }

  ngOnInit() {
  }

  onSuccess(rsp: StsA360RegistrationResponseModel): void {
    this.errors = [];
    if (rsp.success) {

      this.username = rsp.info.emailAsUserName ? rsp.info.emailAsUserName : rsp.info.userNameAsUserName;
      this.userId = rsp.info.id;

      if (!this.username) {
        let err = new StsNotification();

        if (rsp['sts-code'] === 'sts-reg-error-') {
          err.code = 'sts-forgot-username-not-registered';
          err.description = 'User not registered';
        } else {
          err.code = 'sts-forgot-username-empty';
          err.description = 'User ID not found';
        }

        err.level = StsNotificationType.Error;
        this.errors.push(err);
      }

    } else {

      if (rsp.errors.length) {
        for (let ei = 0; ei < rsp.errors.length; ei++) {
          let err = new StsNotification();
          err.code = 'sts-registration-invalid';
          err.description = rsp.errors[ei];
          err.level = StsNotificationType.Error;
          this.errors.push(err);
        }
      } else if (rsp.info.errorCode) {
        let err = new StsNotification();
        err.code = rsp["sts-code"];
        err.description = rsp.info.errorCode;
        err.level = StsNotificationType.Error;
        this.errors.push(err);
      }

    }
  }

  gotoHome(mode: StsRegistrationType): void {
    this.router.navigateByUrl('/');
  }

  showErrors(errs: StsNotification[]): void {
    this.errors = errs;
  }

}
